import BpkIconAi from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/ai';
import BpkText, {
  TEXT_STYLES,
  TEXT_COLORS,
} from '@skyscanner-internal/backpack-web/bpk-component-text';
import classnames from 'classnames';

import STYLES from './AISummary.module.scss';

type AISummaryInfo = {
  summaryPhrases: string[];
  prefix: string;
  suffix: string;
  isVisible: boolean;
};

const AISummary = ({
  isVisible,
  prefix,
  suffix,
  summaryPhrases,
}: AISummaryInfo) => {
  if (!isVisible) return null;
  const isEmpty = !summaryPhrases || summaryPhrases.length === 0;

  const containerClassName = classnames(STYLES.HotelCard__aiSummaryContainer, {
    [STYLES.HotelCard__aiSummaryContainer__empty]: isEmpty,
  });

  if (isEmpty) {
    return <div className={containerClassName} aria-hidden="true" />;
  }

  return (
    <div className={containerClassName}>
      <div className={STYLES.HotelCard__aiSummaryContainer__aiSummaryContent}>
        <BpkText
          tagName="span"
          textStyle={TEXT_STYLES.sm}
          className={STYLES.HotelCard__aiSummaryContainer__aiSummaryPoints}
        >
          <span
            className={STYLES.HotelCard__aiSummaryContainer__aiSummaryTitle}
          >
            {prefix}:
          </span>
          {summaryPhrases.join(' • ')}
        </BpkText>
      </div>
      <div className={STYLES.HotelCard__aiSummaryContainer__aiSummaryFooter}>
        <BpkText
          tagName="span"
          textStyle={TEXT_STYLES.sm}
          color={TEXT_COLORS.textSecondary}
          className={STYLES.HotelCard__aiSummaryContainer__aiSummaryFooterText}
        >
          <BpkIconAi
            className={
              STYLES.HotelCard__aiSummaryContainer__aiSummaryFooterIcon
            }
          />
          {suffix}
        </BpkText>
      </div>
    </div>
  );
};

export default AISummary;
